const createSlice = (objectOfTypes, state, incrementAmount) => {
  return {
    [objectOfTypes.FIRST_ONE]: [-1],
    [objectOfTypes.FIRST_THREE]: [-3],
    [objectOfTypes.SHOW_INCREMENT_AMOUNT]: [-incrementAmount],
    [objectOfTypes.SHOW_ALL]: [],
    [objectOfTypes.HIDDEN]: [0, 0]
  }[state];
}

export default createSlice;
